import { TFunction } from "i18next";

export const extraResponsibilityValues = {
  ATTACHMENT: "ATTACHMENT",
  CURRENT_RESPONSIBILITY: "CURRENT_RESPONSIBILITY",
  ROUTINE_RESPONSIBILITY: "ROUTINE_RESPONSIBILITY",
  EXTRA_RESPONSIBILITY: "EXTRA_RESPONSIBILITY",
  SUPERVISE_RESPONSIBILITY: "SUPERVISE_RESPONSIBILITY",
};

export const extraResponsibilityTypes = (
  t: TFunction<"translation", undefined>,
) => [
  {
    label: t("EMPLOYEES.EXTRA_RESPONSIBILITY.RESPONSIBILITY_TYPES.ATTACHMENT"),
    value: extraResponsibilityValues.ATTACHMENT,
  },
  {
    label: t("EMPLOYEES.EXTRA_RESPONSIBILITY.RESPONSIBILITY_TYPES.CURRENT"),
    value: extraResponsibilityValues.CURRENT_RESPONSIBILITY,
  },
  {
    label: t("EMPLOYEES.EXTRA_RESPONSIBILITY.RESPONSIBILITY_TYPES.ROUTINE"),
    value: extraResponsibilityValues.ROUTINE_RESPONSIBILITY,
  },
  {
    label: t("EMPLOYEES.EXTRA_RESPONSIBILITY.RESPONSIBILITY_TYPES.EXTRA"),
    value: extraResponsibilityValues.EXTRA_RESPONSIBILITY,
  },
  {
    label: t("EMPLOYEES.EXTRA_RESPONSIBILITY.RESPONSIBILITY_TYPES.SUPERVISE"),
    value: extraResponsibilityValues.SUPERVISE_RESPONSIBILITY,
  },
];
